<template>
    <div class="qclist">
        <div class="clearfix qcnav">
            <!-- <row>
                <van-col span="2">
                    <Icon name="arrow-left" size="26" @click="getBack" />
                </van-col>
                <van-col span="22" align="center" justify="center" style="font-size:19px;">维修项目</van-col>
            </row> -->
            <NavBar
                class="restclass"
                title="维修项目"
                left-text="返回"
                left-arrow
                @click-left="getBack" />
        </div>

        <div class="clientList">
            <row class="search">
                <van-col span="20"><search v-model="parameter.keyword" placeholder="请输入搜索关键词" class="search" /></van-col>
                <van-button type="primary" size="normal" round style="font-size:13px;margin-top:10px;"
                    @click="search">查&nbsp;询</van-button>
            </row>
            <row style="margin:5px">
                <van-col span="4"><van-button type="primary" size="normal" round style="font-size:10px;"
                    @click="searchAll">全部</van-button></van-col>
                <!-- <van-col span="20">
                    <dropdown-menu active-color="#ee0a24">
                        <dropdown-item v-model="value2" :options="option2" />
                    </dropdown-menu>
                </van-col> -->
            </row>
            <PullRefresh v-model="refreshing" @refresh="onRefresh">
                <List v-model="loading"
                    :finished="finished"
                    :finished-text="finishedText" @load="onLoad">
                    <div
                        v-for="(item,index) in list"
                        :key="item.Id"
                        class="list clearfix">
                        <div class="clearfix">
                            <row>
                                <van-col span="1">
                                    <p>{{ index + 1 }}</p>
                                </van-col>
                                <van-col span="20">
                                    <p class="listp">
                                        <span class="info-span-top">{{ item.maintainItem }}</span>
                                        <span class="info-span-top">{{ item.sheetNo }}</span>
                                    </p>
                                    <p class="listp margin-top5">
                                        <span class="info-span-bottom" style="width:25%">{{ item.owner }}</span>
                                        <span class="info-span-bottom" style="width:30%">{{ item.teamName }}</span>
                                        <span class="info-span-bottom" style="width:35%">{{ `${item.category}-${item.model}` }}</span>

                                    </p>
                                    <p class="listp margin-top5">
                                        <span class="info-span-bottom" style="width:100%">{{ `${item.vehicleCode}-${item.barCode}` }}</span>
                                    </p>
                                </van-col>
                                <van-col v-if="$_has('maintain:maintainitemlist:edit')&&!item.isNotMaintain" span="3" @click="dispatch(item.workOrderItemId)"><van-button type="primary" round>返修</van-button></van-col>
                            </row>
                        </div>
                    </div>
                </List>
            </PullRefresh>

            <p v-if="list.length === 0" class="noList">暂无数据</p>
        </div>
        <bottom />
    </div>
</template>

<script>

import { Icon, List, Button, Col, Row, Search, DropdownMenu, DropdownItem, PullRefresh, NavBar } from 'vant'
import bottom from '@/components/bottom'
import { getWorkOrderitemList } from '@/api/maintain'
import { getcategory } from '@/api/basics'

export default {
    name: 'Partsrepair',
    components: {
        bottom,
        Icon, List, [Button.name]: Button, [Col.name]: Col, Row, Search, DropdownMenu, DropdownItem, PullRefresh, NavBar
    },
    data() {
        return {
            finishedText: '已加载全部',
            refreshing: false,
            loading: false,
            finished: false,
            parameter: {
                keyword: '',
                enumWorkOrderStatus: [],
                category: '',
                pageIndex: 1, // 当前页
                pageSize: 10 // 每页多少条
            },
            list: [],
            value1: 0,
            value2: '',
            option1: [
                { text: '按状态', value: 0 },
                { text: '维修中', value: 3 },
                { text: '维修中-领料完成', value: 4 },
                { text: '维修中-质检不通过', value: 5 }
            ],
            option2: []
        }
    },
    created() {
        if (this.$route.query.keyword) {
            this.parameter.keyword = this.$route.query.keyword
        }
        this.initCategory()
    },
    methods: {
        getBack() {
            this.$router.push({ path: '/' })
        },
        scan() {

        },
        initCategory() {
            getcategory()
                .then((res) => {
                    if (res.code == 200) {
                        var data = res.data
                        this.option2 = [{ text: '按类别', value: '' }]
                        var i = 0
                        for (i; i < data.length; i++) {
                            var item = {}
                            item.text = data[i].content
                            item.value = data[i].content
                            this.option2[i + 1] = item
                        }
                    }
                })
        },
        onLoad() {
            this.loading = true
            if (this.refreshing) {
                this.parameter.pageIndex = 1
                this.list = []
            }
            getWorkOrderitemList(this.parameter)
                .then((res) => {
                    if (res.code == 200) {
                        this.parameter.pageIndex === 0 ? this.list = res.data : this.list = this.list.concat(res.data)
                        // 判读是否加载到最后一页
                        this.list.length >= res.totalCount ? this.finished = true : this.parameter.pageIndex++
                        this.list.length === 0 ? this.finishedText = '' : this.finishedText = '已加载全部'
                        // 请求完毕后隐藏正在 加载样式
                        this.loading = false
                        this.refreshing = false
                    }
                })
        },
        dispatch(id) {
            if (this.$_has('maintain:workorder:view')) {
                this.$router.push({ path: '/fxdispatchdetails', query: { id: id, type: '返修派工单' }})
            } else {
                this.$router.push({
                    path: '/404'
                })
            }
        },
        onRefresh() {
            this.finished = false
            this.onLoad()
        },
        search() {
            this.refreshing = true
            this.onLoad()
        },
        searchAll() {
            this.parameter.enumWorkOrderStatus = []
            this.parameter.category = ''
            this.parameter.keyword = ''
            this.value1 = 0
            this.value2 = ''
            this.refreshing = true
            this.onLoad()
        },
        convertStatus(status) {
            switch (status) {
            case 3:
                return '维修中'
            case 4:
                return '维修中-领料完成'
            case 5:
                return '维修中-质检不通过'
            }
        }
    }
}
</script>
<style>
.restclass .van-nav-bar{
    height: 1rem!important;
    background: #3982cc!important
}
</style>
<style lang='scss' scoped>

.qclist{
    width: 100%;
  .clientList{
    padding: 0px 40px;
    h2{
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 25px;
    }
    .search{
      margin:8px 0;
      button{
        width: 100px;
        height: 50px;
        color: #ffffff;
        margin-left: 10px;
        border-radius: 10px;
      }
    }
    .list{
      padding: 20px 0;
      border-bottom: 1px solid #ccc;
      h3{
        font-size: 38px;
        font-weight: 700;
      }
      .msg{
        padding: 20px 0;
        font-size: 18px;
        .phone{
          margin-left: 10%;
          color: #3498db;
        }
      }
      p{
        color: #999;
        font-size: 20px;
        padding: 5px 0;
      }
    }
  }
}
.info-span-top{
    display:inline-block;
    padding:0px 8px;
    color:#000;
    width:45%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.info-span-bottom{
    display:inline-block;
    padding:0px 8px;
    color:#000;
    width:46%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.info-span-red{
    padding:0px 8px;
    color:#f00;
}
</style>

<style lang='scss' scoped>
.nav{
  width: 100%;
  padding: 20px 0px;
  background: #3498ff;
  color: #fff;
  .nav-title{
    width: 100%;
    font-size: 30px;
    text-align: center;
    display: block;
  }
}
.noList{
  text-align: center;
  margin-top: 50%;
  font-size: 26px;
  color: #ccc;
}
.van-dialog{
  width: 70%;
  height: 15%;
  .van-dialog__content{
    height: 65%;
    padding-top: 5%;
    text-align: center;
    .van-dialog__message{
      text-align: center;
      font-size: 26px;
    }
  }
  .van-dialog__footer--buttons{
    height: 35%;
    .van-button{
      width: 50%;
      height: 100%;
      .van-button__text{
        font-size: 26px;
      }
    }
  }
}

</style>

